import React = require("react");
import {ReactNode} from "react";
import "./TabSelector.scss";
import {themeDefaultValues, veboxDefaultTheme} from "../index";

interface TabSelectorProps {
    buttons: TabButton[];
    onSelect: (key: any) => void;
    activeButtonKey: any;
    isSecondLevelTabbar?: boolean;
}

export interface TabButton {
    key: any;
    text: string;
    enabled?: boolean;
}

export class TabSelector extends React.Component<TabSelectorProps, {}> {

    /**
     * Render a button. If it is selected the onSelect function is never called.
     */
    private static renderButton(index: number, button: TabButton, selected: boolean, onSelect: () => void, isSecondLevelButton?: boolean): ReactNode {
        const clickFunction = () => {
            if (!selected) {
                onSelect();
            }
        };

        if (isSecondLevelButton) {
            return (
                <div
                    key={index}
                    className={"second-level-tabbar__button " +
                    (button.enabled === false
                        ? "tab-selector__button--disabled"
                        : (selected ? "selected" : ""))}
                    onClick={clickFunction}
                    style={{
                        background: button.enabled && selected ?  "var(--second-level-tabbar-button-bg)" : "",
                        fontWeight: selected ? 600 : null,
                        transition: "var(--hover-transition-value)"
                    }}
                >
                    <span className={"tab-selector__button--text"}>{button.text}</span>
                </div>
            );
        } else {
            return (
                <div
                    key={index}
                    className={"tab-selector__button " +
                    (button.enabled === false
                        ? "tab-selector__button--disabled"
                        : (selected ? "tab-selector__button--selected" : ""))}
                    onClick={clickFunction}
                    style={{
                        background: button.enabled && selected ?  veboxDefaultTheme.palette.brand.main : "",
                        color: selected || button.enabled ? "white" : null,
                        fontWeight: selected ? 600 : null,
                        opacity: selected || button.enabled ? null : 0.7,
                        border: button.enabled && !selected ? "1px solid var(--button-bg)" : "1px solid transparent",
                        margin: "0 2px",
                        borderRadius: "var(--danfoss-border-radius)",
                        transition: "var(--hover-transition-value)"
                    }}
                >
                    <span className={"tab-selector__button--text"}>{button.text}</span>
                </div>
            );
        }
    }

    constructor(props) {
        super(props);
    }

    public render() {
        const buttons: ReactNode[] = this.props.buttons.map((button: TabButton, index: number) => {
                return TabSelector.renderButton(
                    index,
                    button,
                    button.key === this.props.activeButtonKey,
                    () => {
                        this.props.onSelect(button.key);
                    },
                    this.props.isSecondLevelTabbar
                );
            },
        );
        return (
            <div className={this.props.isSecondLevelTabbar ? "second-level-tabbar" : "tab-selector"}>
                {buttons}
            </div>
        );
    }
}
